// Utils
import hasRole from './hasRole'

// Constants
import {
  ROLE_STAFF,
} from '../constants'

// Exports
export default hasRole(ROLE_STAFF)
